const markers = [
  {
    geocode: [-15.822499, -48.069254],
    popUp: "HRT",
  },
  {
    geocode: [-15.83733, -48.060573],
    popUp: "HSVP",
  },
  {
    geocode: [-15.648064, -47.792811],
    popUp: "HRS",
  },
  {
    geocode: [-15.818028, -47.986391],
    popUp: "HRGu",
  },
  {
    geocode: [-15.853309, -48.073219],
    popUp: "HRSam",
  },
  {
    geocode: [-15.67493, -48.203732],
    popUp: "HRBz",
  },
  {
    geocode: [-15.781722, -47.781664],
    popUp: "HRL",
  },
  {
    geocode: [-15.625454, -47.652764],
    popUp: "HRPL",
  },
  {
    geocode: [-16.0236, -48.06868],
    popUp: "HRG",
  },
  {
    geocode: [-15.78432, -47.882287],
    popUp: "HRAN",
  },
  {
    geocode: [-15.8154, -48.096266],
    popUp: "HRC",
  },
  {
    geocode: [-15.823527, -47.896826],
    popUp: "HMIB",
  },
];

export default markers;
